import { render } from "./TestComponent.vue?vue&type=template&id=4bb324d9"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"

import "./TestComponent.vue?vue&type=style&index=0&id=4bb324d9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__